import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../Modals/ConfirmationModal/ConfirmationModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ClientCard.css';
import { FaEdit, FaTimes } from 'react-icons/fa';
import AddClientModal from '../Modals/AddClientModal/AddClientModal';
import { sanitizeUrl } from '../../utils/functions';
import AuthenticatedImage from '../AuthenticatedImage/AuthenticatedImage';
import { useNotification } from '../notifications/useNotification';

const ClientCard = ({ profilePic, client, updateClientsPage, currentPage }) => {
    const { t } = useTranslation();
    const { showError } = useNotification();
    const navigate = useNavigate();
    const [showEditClientModal, setShowEditClientModal] = useState(false);
    const [showDeleteClientModal, setShowDeleteClientModal] = useState(false);

    const removeClient = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/clients/${id}`, { withCredentials: true });
            updateClientsPage(currentPage)
            setShowDeleteClientModal(!showDeleteClientModal)
        } catch (error) {
            console.log("ERROR in getData() in CLIENT ROW COMPONENT:\n" + error);
            showError(t("unknown-error"))
        }
    }

    const handleCardClick = () => {
        navigate(`/client/${client._id}`);
    };

    return (
        <>
            <div className="client-card">
                <div className="client-card-top">
                    <AuthenticatedImage
                        src={sanitizeUrl(client.profilePhotoUrl)}
                        fallbackSrc="/images/anonymous_avatar_icon.jpg"
                        alt='pic'
                        className='client-card-image client-card-item'
                        onClick={handleCardClick}
                    />
                    <div className="client-card-icons">
                        <div id='edit-icon-container' className='icon-container' onClick={() => setShowEditClientModal(!showEditClientModal)}>
                            <FaEdit className="edit-icon" />
                        </div>
                        <div id='delete-icon-container' className='icon-container' onClick={() => setShowDeleteClientModal(!showDeleteClientModal)}>
                            <FaTimes className="delete-icon" />
                        </div>
                    </div>
                </div>

                <div className="client-card-info" onClick={handleCardClick}>
                    <h3>{client.name} {client.surname}</h3>
                    <p>{client.email}</p>
                    <p>{client.phone}</p>
                    <p className={`diet-status ${client.dietStatus ? 'active' : 'inactive'}`}>
                        {client.dietStatus ? t('diet-active') : t('diet-inactive')}
                    </p>
                </div>
            </div>
            {showEditClientModal &&
               <AddClientModal
                    client={client}
                    setShowModal={setShowEditClientModal}
                    onSave={() => updateClientsPage(currentPage)}
                />
            }
            {showDeleteClientModal && 
                <ConfirmationModal
                    titleText={t("delete-client") + ": " + client.name + " " + client.surname}
                    bodyText={t("confirm-delete-client")}
                    handleConfirm={() => removeClient(client._id)}
                    handleClose={() => setShowDeleteClientModal(!showDeleteClientModal)}
                />
            }
        </>
        
    );
};

export default ClientCard;
